<template>
  <div class="select-poi">
    <!-- 显示地图 -->
    <point-on-map-mini @getLatLng="getLatLng"
                       @selectSuggestion="selectSuggestion"
                       :porplat="lat"
                       :proplng="lng"
                       height="350"
                       class="select-poi-show-map"
                       style="margin-bottom:20px"
                       ref="pointOnMap"></point-on-map-mini>
    <!-- tap块 -->
    <el-tabs v-model="activeName"
             class="select-poi-mode"
             type="border-card">
      <!-- 添加 -->
      <el-tab-pane label="添加POI"
                   name="first">
        <div class="add-poi-tab-pane">
          <el-form :label-position="labelPosition"
                   :model="formLabelAlign"
                   label-width="90px">
            <el-form-item label="POI名称:">
              <el-input style="width: 250px"
                        size="mini"
                        v-model="formLabelAlign.poi_name"></el-input>
            </el-form-item>
            <el-form-item size="mini"
                          label="所属目的地:">
              <el-cascader style="width: 150px"
                           size="mini"
                           :show-all-levels="false"
                           v-model="formLabelAlign.dest"
                           :options="option"
                           :props="defaultProp"
                           clearable
                           filterable></el-cascader>
            </el-form-item>
            <el-form-item label="POI坐标:">
              <p>

                <el-input style="width: 80%"
                          size="mini"
                          placeholder="经度lng"
                          v-model="formLabelAlign.location.lng"></el-input>
              </p>
              <p>
                <el-input style="width: 80%"
                          size="mini"
                          placeholder="纬度lat"
                          v-model="formLabelAlign.location.lat"></el-input>
              </p>

            </el-form-item>
          </el-form>
        </div>
        <div style="text-align:center;margin-top:30px">
          <!-- 提交 -->
          <el-button size="mini"
                     @click="submitPOI"
                     type="primary">提交并绑定POI</el-button>
          <!-- 取消 -->
          <el-button size="mini"
                     @click="closeSubmitPOI"
                     type="">关闭</el-button>
        </div>

      </el-tab-pane>

      <!-- 选取poi -->
      <el-tab-pane label="选择POI"
                   name="second">
        <!-- 筛选 -->
        <div style="margin-bottom:15px">
          <span>选择目的地：</span>
          <!-- 选择目的地 -->
          <el-cascader size="mini"
                       style="width:40%"
                       v-model="destId"
                       :options="option"
                       @change="selectPoiDest"
                       :props="selectDestProp"
                       clearable></el-cascader>
          <!-- 搜索poi -->
          <!-- <span style="margin-left: 20px">选择POI：</span>
            <el-autocomplete
              size="mini"
              class="inline-input"
              v-model="state1"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="handleSelect"
            ></el-autocomplete> -->
          <!-- 绑定按钮 -->
          <el-button @click="bandPoiToTraverPoint"
                     size="mini"
                     style="float: right"
                     type="primary">绑定POI:{{ poi_id }}</el-button>
        </div>
        <!-- 选择 -->
        <div class="little-card-poi">

          <!-- poi列表 -->
          <div style="cursor: pointer;  overflow: auto;">
            <el-table ref="multipleTable"
                      :data="poi_list"
                      height="255"
                      tooltip-effect="dark"
                      style="width: 100% ; overflow: auto;"
                      highlight-current-row
                      @current-change="handleSelectionChange">
              <el-table-column label="ID"
                               width="40">
                <template slot-scope="scope">{{ scope.row.poi_id }}</template>
              </el-table-column>
              <el-table-column label="名称"
                               show-overflow-tooltip
                               width="auto">
                <template slot-scope="scope">{{ scope.row.poi_name }}</template>
              </el-table-column>
              <el-table-column label="所在地"
                               width="70">
                <template slot-scope="scope">{{ scope.row.dest }}</template>
              </el-table-column>
              <el-table-column prop=""
                               label="坐标"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <p>{{ scope.row.lat }}</p>
                  <p>{{ scope.row.lng }}</p>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PointOnMapMini from '../../components/map/PointOnMapMini'
export default {
  name: 'select-or-add-poi-list',
  components: {
    PointOnMapMini,
  },
  data() {
    return {
      activeName: 'first',
      // 获取指定目的地poi列表
      destId: '',
      option: [], // 目的地可选项
      poi_list: [],
      poi_id: '',
      lat: null,
      lng: null,
      //  选择poi 选择器属性
      selectDestProp: {
        // checkStrictly: true,
        emitPath: false,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      //   添加poi选择器属性
      defaultProp: {
        multiple: false,
        checkStrictly: true,
        // emitPath: false,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      // 表单
      formLabelAlign: {
        poi_name: '',
        dest: '', // 选择的目的地
        location: {
          lat: '',
          lng: '',
        },
      },
      labelPosition: 'left',
    }
  },
  props: {
    attribute: null,
    proplat: {
      type: Number,
      default: 109.5142936706543,
    },
    proplng: {
      type: Number,
      default: 18.243943345260536,
    },
  },
  created() {
    this.loadDest()
    // this.getPoiHubList();
  },
  methods: {
    // 关闭窗口
    closeSubmitPOI() {
      this.$emit('closeSubmitPOI')
    },
    // 选择poi时
    handleSelectionChange(val) {
      // 更新当前poi_id
      if (val) {
        this.poi_id = val.poi_id
      }

      // 用于显示
      this.$refs.pointOnMap.lat = parseFloat(val.lat)
      this.$refs.pointOnMap.lng = parseFloat(val.lng)
      this.$refs.pointOnMap.showPoiMarker(
        parseFloat(val.lat),
        parseFloat(val.lng)
      )
      // console.log(this.$refs.pointOnMap);
      // 输入定位显示在地图上
    },
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
      })
    },
    // 选择poi所在目的地
    selectPoiDest() {
      // 切片获取最后一个id/ 是否严格遵循
      this.destId
      // 通过借口获取 该id 拥有的poi 条目
      this.getPoiHubList(this.destId)
    },
    // 获取 poi_hub列表【无用】
    getPoiHubList(dest_id) {
      this.$http
        .get(`/get_poi_hub_list?source_map=2&dest_id=${dest_id}`)
        .then((res) => {
          this.poi_list = res.data.poi_list
        })
    },
    // 获取坐标
    getLatLng(lat, lng, map_source) {
      this.formLabelAlign.location.lat = lat
      this.formLabelAlign.location.lng = lng
      this.formLabelAlign.map_source = map_source
    },
    // 提交POI 到数据库
    submitPOI() {
      this.$http.post('/add_poi', this.formLabelAlign).then((res) => {
        if (res.data.errno == '0') {
          this.$emit('submitPoi', res.data.poi_id, this.attribute)
        } else {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: '添加完成',
            })
          } else if (res.data.errno == '4003') {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
            })
          }
        }
      })
    },
    bandPoiToTraverPoint() {
      this.$emit('submitPoi', this.poi_id, this.attribute)
    },
    // 地图选择关键词建议点后
    selectSuggestion(val) {
      this.formLabelAlign.location.lat = val.lat
      this.formLabelAlign.location.lng = val.lng
      this.formLabelAlign.poi_name = val.title
      this.formLabelAlign.dest = val.dest
      this.formLabelAlign.map_source = val.map_source
    },
  },
}
</script>

<style>
.select-poi {
  display: flex;
  margin: 20px 0;
}
.select-poi-show-map {
  width: 55%;
  border: 1px solid rgb(207, 207, 207);
}
.select-poi-mode {
  width: 45%;
  height: 428px;
}
.little-card-poi {
  display: flex;
  padding: 15px;
  flex-wrap: wrap;
  /* background-color: wheat; */
  flex-direction: column;
  border: 1px solid lightgray;
  height: 100%;
}
.add-poi-tab-pane {
  padding: 20px;
  border: 1px solid lightgrey;
}
</style>